import FrequentlyUsedOrderSearchCriteriaDto from "@/dto/FrequentlyUsedOrderSearchCriteriaDto";
import httpClient from "@/services/http/mainServerClient";

/** ❗常用搜索中，传入companyId代表是跨平台中使用，传入shopId代表单个店铺使用 */
interface AddFrequentlyOrderSearchCriteriaParams {
    data: string;
    name: string;
    /** shopId和companyId必须要有一个 */
    shopId?: number;
    companyId?: number;
}

export function addFrequentlyOrderSearchCriteria(
    params: AddFrequentlyOrderSearchCriteriaParams,
): Promise<FrequentlyUsedOrderSearchCriteriaDto> {
    return httpClient.post("/frequently_used_order_search_criteria/add", params);
}

export function deleteFrequentlyOrderSearchCriteria(params: { id: number }): Promise<void> {
    return httpClient.post("/frequently_used_order_search_criteria/delete", params);
}

export type GetFrequentlyOrderSearchCriteriaListParams = { shopId: number } | { companyId: number };

export function getFrequentlyOrderSearchCriterionList(
    params: GetFrequentlyOrderSearchCriteriaListParams,
): Promise<FrequentlyUsedOrderSearchCriteriaDto[]> {
    return httpClient.post("/frequently_used_order_search_criteria/list", params);
}

interface UpdateFrequentlyOrderSearchCriteriaParams {
    data: string;
    id: number;
    name: string;
    sortedIndex?: number;
}

export function updateFrequentlyOrderSearchCriteria(
    params: UpdateFrequentlyOrderSearchCriteriaParams,
): Promise<FrequentlyUsedOrderSearchCriteriaDto> {
    return httpClient.post("/frequently_used_order_search_criteria/update", params);
}

export function batchUpdateFrequentlyOrderSearchCriteria(
    params: UpdateFrequentlyOrderSearchCriteriaParams[],
): Promise<FrequentlyUsedOrderSearchCriteriaDto> {
    return httpClient.post("/frequently_used_order_search_criteria/batch_update", params);
}
